// TODO: This import uses around 14% of app bundle size
import {
  Exchange_v2__factory,
  EarningsEscrow__factory,
  ERC20__factory,
  // IRewardVault__factory,
  // FixedIncomeVaultProvider_v1,
  // FixedIncomeVaultProvider_v1__factory,
  // FixedIncomeVaultProviderStateAggregator_v1,
  // FixedIncomeVaultProviderStateAggregator_v1__factory,
  // EarningsEscrow_v2,
  EarningsEscrow_v2__factory,
} from '@katanaperps/katana-perps-sdk/typechain';
import { ContractTransactionResponse } from 'ethers';

export {
  // TODO: needed ?
  /** USDC Ethers.js factory representing ERC20 token exported from our SDK */
  ERC20__factory,

  /** IDEX 2024 (v4/ikon) Exchange Ethers.js factory exported from our SDK */
  // Exchange_v4__factory,

  /** IDEX 2024 (v4/ikon) Earnings Escrow Ethers.js factory exported from our SDK */
  // EarningsEscrow__factory,

  /** 2025-10 Kuma Exchange Ethers.js factory exported from our SDK */
  Exchange_v2__factory as KatanaExchange_v2__factory,

  /** Legacy 2025 Kuma Earnings Escrow Ethers.js factory exported from our SDK */
  EarningsEscrow__factory as KumaEarningsEscrow__factory,

  /** Latest 2026 Katana Escrow for Milestone competition per round claiming exported from our SDK */
  EarningsEscrow_v2__factory,

  /** Latest Kuma Reward Vault Ethers.js factory */
  // IRewardVault__factory,

  /** Latest Kuma Vault provider Ethers.js factory */
  // FixedIncomeVaultProvider_v1__factory,

  /** Latest Kuma Vault vault provider Aggregator Ethers.js factory */
  // FixedIncomeVaultProviderStateAggregator_v1__factory,
};

// TODO: vaults fake calls until it's available in the SDK again

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FixedIncomeVaultProvider_v1 {
  export type VaultBalanceForWalletSummaryStructOutput = {
    costBasis: bigint;
    initialDepositTimestampInS: bigint;
    lockedQuantity: bigint;
    owedQuantity: bigint;
    pendingDepositQuantity: bigint;
    quantityAvailableToWithdraw: bigint;
    withdrawalLimitWindowEndTimestampInS: bigint;
  };
  export type VaultConfigurationFieldsStructOutput = {
    managerWallet: string;
    effectiveTimestampInS: bigint;
    interestMultiplier: bigint;
    maximumNetDeposits: bigint;
    maximumTotalOwedQuantityAvailableMultiplierToInitiateExit: bigint;
    minimumTotalOwedQuantityAvailableMultiplierToAllowManagerWalletWithdrawal: bigint;
    minimumUnappliedWithdrawalAgeInSToInitiateExit: bigint;
    withdrawalLimitPercentForDepositors: bigint;
    withdrawalLimitPercentForVault: bigint;
  };
  export type VaultSummaryStructOutput = {
    isDepositEnabled: boolean;
    isExited: boolean;
    isLiquidated: boolean;
    didManagerWalletWithdrawExit: boolean;
    exitedAccountValue: bigint;
    exitedAtTimestampInS: bigint;
    exitedTotalOwedQuantity: bigint;
    managerLockedQuantity: bigint;
    netDeposits: bigint;
    numDepositorWallets: bigint;
    totalLockedQuantity: bigint;
    totalOwedQuantity: bigint;
    totalPendingDepositQuantity: bigint;
    configurationFields: FixedIncomeVaultProvider_v1.VaultConfigurationFieldsStructOutput;
  };
}

/** @deprecated */
const WRITE_CALL = async (
  ..._params: any[]
): Promise<ContractTransactionResponse> => {
  throw new Error('Vaults not enabled');
};

/** @deprecated */
const READ_CALL = async <T>(..._params: any[]): Promise<T> => {
  throw new Error('Vaults not enabled');
};

/** @deprecated */
export const FixedIncomeVaultProvider_v1__factory = {
  connect: (..._params: any[]) => {
    throw new Error('Vaults not enabled');
    return {
      MIN_INTEREST_MULTIPLIER: WRITE_CALL,
      MAX_INTEREST_MULTIPLIER: WRITE_CALL,
      MAX_MAXIMUM_NET_DEPOSITS: WRITE_CALL,
      exitWallet: WRITE_CALL,
      withdrawExit: WRITE_CALL,
      setDepositEnabled: WRITE_CALL,
      managedAccountUpgradeBlockTimestampDelayInS: READ_CALL<bigint>,
      cancelManagedAccountUpgrade: WRITE_CALL,
      finalizeManagedAccountUpgrade: WRITE_CALL,
      initiateManagedAccountUpgrade: WRITE_CALL,
      loadVaultSummary: READ_CALL,
      loadVaultBalanceForWalletSummary:
        READ_CALL<FixedIncomeVaultProvider_v1.VaultBalanceForWalletSummaryStructOutput>,
      vaultConfigurationUpgradesByManagerWallet: READ_CALL<{
        exists: boolean;
        newVaultConfigurationFields: FixedIncomeVaultProvider_v1.VaultConfigurationFieldsStructOutput;
        blockTimestampThreshold: bigint;
      }>,
    };
  },
};

/** @deprecated */
const _IRewardVault__factory = {
  connect: (..._params: any[]) => {
    throw new Error('Vaults not enabled');
    return {
      earned: READ_CALL<bigint>,
      operator: READ_CALL<string>,
      getReward: WRITE_CALL,
      setOperator: WRITE_CALL,
    };
  },
};

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace FixedIncomeVaultProviderStateAggregator_v1 {
  export type LoadVaultWithdrawalQueueResultStructOutput = {
    nonce: bigint;
    depositorWallet: string;
    grossQuantity: bigint;
  };
  export type LoadVaultDepositorsResultStructOutput = {
    costBasis: bigint;
    initialDepositTimestampInS: bigint;
    owedQuantity: bigint;
  };
}

/** @deprecated */
export const FixedIncomeVaultProviderStateAggregator_v1__factory = {
  connect: (..._params: any[]) => {
    throw new Error('Vaults not enabled');
    return {
      loadVaultConfigurations: READ_CALL<
        FixedIncomeVaultProvider_v1.VaultConfigurationFieldsStructOutput[]
      >,
      loadVaultWithdrawalQueue: READ_CALL<
        FixedIncomeVaultProviderStateAggregator_v1.LoadVaultWithdrawalQueueResultStructOutput[]
      >,
      loadVaultDepositorsByManagerWallet: READ_CALL<
        FixedIncomeVaultProviderStateAggregator_v1.LoadVaultDepositorsResultStructOutput[]
      >,
      loadVaultDepositorsByDepositorWallet: READ_CALL<
        FixedIncomeVaultProviderStateAggregator_v1.LoadVaultDepositorsResultStructOutput[]
      >,
    };
  },
};
